import { render, staticRenderFns } from "./UserRelationDialog.vue?vue&type=template&id=77e396d6&scoped=true"
import script from "./UserRelationDialog.vue?vue&type=script&lang=js"
export * from "./UserRelationDialog.vue?vue&type=script&lang=js"
import style0 from "./UserRelationDialog.vue?vue&type=style&index=0&id=77e396d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e396d6",
  null
  
)

export default component.exports